import React from "react";
import "./loader.scss";
import { PulseLoader } from "@pulselabs-ai/shared-fe-ui";

const Loader: React.FC = () => {
  return (
    <div className="loader-over">
      <PulseLoader />
    </div>
  );
};

export default Loader;
